export default {
  "ErrorDetails": "_ErrorDetails_15btl_1",
  "ErrorOutput": "_ErrorOutput_15btl_5",
  "ErrorDetailsToggle": "_ErrorDetailsToggle_15btl_19",
  "Error": "_Error_15btl_1"
};import "ni:sha-256;qnmlSqTpDxK9YMRSPyQU6khpiLzZRULZWk8QbEwvq8Q";